import type {
  IChallenge,
  IChallengeTask,
  IChallengeTaskReport,
  IChallengeUserReport,
} from '@/types/Data'
import type {
  IDeleteChallenge,
  IDeleteChallengeTask,
  IGetChallengeList,
  IGetChallengeTaskList,
  IGetChallengeTaskReport,
  IGetChallengeUserReport,
  IPayloadChallenge,
  IPayloadChallengeTask,
  IReorderChallengeTask,
} from '@/types/Request/CommonAPI'
import { JsonToFormDataSimple } from '@/utils-ts'
import BaseService from '../BaseService'

export class ChallengeServices extends BaseService {
  /* Challenges */

  GetChallengeList(payload: IGetChallengeList) {
    return this.GET<IChallenge[]>(this.PATHS.GET_CHALLENGE_LIST, payload)
  }

  CreateChallenge(payload: IPayloadChallenge) {
    return this.POST<string>(this.PATHS.CREATE_CHALLENGE, JsonToFormDataSimple(payload))
  }

  UpdateChallenge(payload: IPayloadChallenge) {
    return this.PUT<IChallenge>(this.PATHS.UPDATE_CHALLENGE, JsonToFormDataSimple(payload))
  }

  DeleteChallenge(payload: IDeleteChallenge) {
    return this.DELETE<string>(this.PATHS.DELETE_CHALLENGE, payload)
  }

  /* Challenges Tasks */

  GetChallengeTaskList(payload: IGetChallengeTaskList) {
    return this.GET<IChallengeTask[]>(this.PATHS.GET_CHALLENGE_TASK_LIST, payload)
  }

  CreateChallengeTask(payload: IPayloadChallengeTask) {
    return this.POST<string>(this.PATHS.CREATE_CHALLENGE_TASK, payload)
  }

  UpdateChallengeTask(payload: IPayloadChallengeTask) {
    return this.PUT<IChallengeTask>(this.PATHS.UPDATE_CHALLENGE_TASK, payload)
  }

  DeleteChallengeTask(payload: IDeleteChallengeTask) {
    return this.DELETE<string>(this.PATHS.DELETE_CHALLENGE_TASK, payload)
  }

  ReorderChallengeTask(payload: IReorderChallengeTask) {
    return this.PUT<string>(this.PATHS.REORDER_CHALLENGE_TASK, payload)
  }

  GetChallengeTaskReport(payload: IGetChallengeTaskReport) {
    return this.GET<IChallengeTaskReport[]>(this.PATHS.GET_CHALLENGE_TASK_REPORT, payload)
  }

  GetChallengeUserReport(payload: IGetChallengeUserReport) {
    return this.GET<IChallengeUserReport[]>(this.PATHS.GET_CHALLENGE_USER_REPORT, payload)
  }

  GetChallengeTaskReportExcel(payload: IGetChallengeTaskReport) {
    return this.EXCEL(this.PATHS.GET_CHALLENGE_TASK_REPORT_EXCEL, false, payload)
  }

  GetChallengeUserReportExcel(payload: IGetChallengeUserReport) {
    return this.EXCEL(this.PATHS.GET_CHALLENGE_USER_REPORT_EXCEL, false, payload)
  }
}
